import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface RecentTransactionsCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function RecentTransactionsCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: RecentTransactionsCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium">Recent Transactions</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center justify-between text-xs p-2 rounded bg-muted/50">
              <div>
                <div className="font-medium">Acme Corp</div>
                <div className="text-muted-foreground">Invoice #1234</div>
              </div>
              <div className="text-right">
                <div className="font-semibold text-green-600">+£12,500</div>
                <Badge variant="secondary" className="text-[10px]">Paid</Badge>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs p-2 rounded bg-muted/50">
              <div>
                <div className="font-medium">Office Supplies Ltd</div>
                <div className="text-muted-foreground">Bill #5678</div>
              </div>
              <div className="text-right">
                <div className="font-semibold text-red-600">-£850</div>
                <Badge variant="secondary" className="text-[10px]">Pending</Badge>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs p-2 rounded bg-muted/50">
              <div>
                <div className="font-medium">Tech Solutions</div>
                <div className="text-muted-foreground">Invoice #9012</div>
              </div>
              <div className="text-right">
                <div className="font-semibold text-green-600">+£8,200</div>
                <Badge variant="secondary" className="text-[10px]">Paid</Badge>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
